import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SecurityPolicy() {
  const { t } = useTranslation();

  return (
    <div className="bg-white max-w-3xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6">
        {t("securityPolicy.title")}
      </h1>

      <section className="prose prose-gray max-w-none">
        <h2 className="text-xl font-semibold mt-8">
          {t("securityPolicy.responsibleDisclosure.title")}
        </h2>
        <p>{t("securityPolicy.responsibleDisclosure.intro")}</p>
        <p>{t("securityPolicy.responsibleDisclosure.ask")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("securityPolicy.responsibleDisclosure.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <h2 className="text-xl font-semibold mt-8">
          {t("securityPolicy.scope.title")}
        </h2>
        <p>{t("securityPolicy.scope.intro")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("securityPolicy.scope.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
        <p>{t("securityPolicy.scope.exclusions")}</p>

        <h2 className="text-xl font-semibold mt-8">
          {t("securityPolicy.expectations.title")}
        </h2>
        <p>{t("securityPolicy.expectations.intro")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("securityPolicy.expectations.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <h2 className="text-xl font-semibold mt-8">
          {t("securityPolicy.commitment.title")}
        </h2>
        <p>{t("securityPolicy.commitment.intro")}</p>
        <ul className="list-disc ml-6 space-y-1">
          {t("securityPolicy.commitment.items", { returnObjects: true }).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>

        <h2 className="text-xl font-semibold mt-8">
          {t("securityPolicy.contact.title")}
        </h2>
        <p>{t("securityPolicy.contact.instructions")}</p>
        <p>
          <a
            href={`mailto:${t("securityPolicy.contact.email")}`}
            className="text-indigo-600 hover:text-indigo-800 font-medium"
          >
            {t("securityPolicy.contact.email")}
          </a>
        </p>
        <p className="text-sm text-gray-500 mt-2">
          {t("securityPolicy.contact.pgpNote")}
        </p>

        <h2 className="text-xl font-semibold mt-8">
          {t("securityPolicy.acknowledgments.title")}
        </h2>
        <p>{t("securityPolicy.acknowledgments.text")}</p>

        <div className="mt-12">
          <Link
            to="/"
            className="inline-flex items-center rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-orange-700"
          >
            {t("securityPolicy.backHome")}
          </Link>
        </div>
      </section>
    </div>
  );
}